exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .v-overlay{position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:none;transition:.3s cubic-bezier(.25,.8,.5,1);z-index:5}.qmodii .v-overlay--absolute{position:absolute}.qmodii .v-overlay:before{background-color:#212121;bottom:0;content:\"\";height:100%;left:0;opacity:0;position:absolute;right:0;top:0;transition:inherit;transition-delay:.15s;width:100%}.qmodii .v-overlay--active{pointer-events:auto;touch-action:none}.qmodii .v-overlay--active:before{opacity:.46}", ""]);

// exports
